/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { linkCellStyle } from './linkCellStyle'

interface Props {
  label?: string
  /** Destination path; without it the label renders as plain text. */
  href?: string
}

/**
 * A cell whose text links somewhere when the row carries the id, and is plain
 * text when it doesn't. Used for the competition and organization columns —
 * both are optional in the payload, and a link to `/schedule/undefined` is
 * worse than no link.
 */
const LinkTextCell = ({ label, href }: Props) => {
  if (!label) {
    return null
  }
  if (!href) {
    return <span css={textStyle}>{label}</span>
  }
  return (
    <a
      css={[textStyle, linkCellStyle]}
      href={href}
      target='_blank'
      rel='noopener noreferrer'
    >
      {label}
    </a>
  )
}

export default LinkTextCell

const textStyle = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
